"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ipv4AddressT = exports.Ipv4Address = void 0;
/**
 * The 4 bytes of an ip address are stored in 32 bits in big endian order.
 * We will switch over to fixed size arrays when they are supported better.
 */
class Ipv4Address {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    addr() {
        return this.bb.readUint32(this.bb_pos);
    }
    static sizeOf() {
        return 4;
    }
    static createIpv4Address(builder, addr) {
        builder.prep(4, 4);
        builder.writeInt32(addr);
        return builder.offset();
    }
    unpack() {
        return new Ipv4AddressT(this.addr());
    }
    unpackTo(_o) {
        _o.addr = this.addr();
    }
}
exports.Ipv4Address = Ipv4Address;
class Ipv4AddressT {
    constructor(addr = 0) {
        this.addr = addr;
    }
    pack(builder) {
        return Ipv4Address.createIpv4Address(builder, this.addr);
    }
}
exports.Ipv4AddressT = Ipv4AddressT;
